export class UserHierarchyRoles
{
    userId: number;
    userHierarchyName: string;
    userHierarchyLabel: string
    userRole: string;
    roleId: number
    Active: boolean
}